// Sidebar icons
import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const HomeIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.8572 12.9014H18.659V19.8396C18.6569 20.2049 18.3683 20.5 18.0129 20.5H14.6455C14.2901 20.5 14.0015 20.2049 13.9994 19.8396V15.955C13.9994 15.7792 13.9311 15.6106 13.8098 15.4868C13.6886 15.3627 13.5241 15.2936 13.353 15.2947H10.6319C10.4611 15.2936 10.2966 15.3627 10.1754 15.4868C10.0541 15.6106 9.98581 15.7792 9.98581 15.955V19.8396C9.98581 20.1998 9.70505 20.4938 9.35471 20.5H5.98729C5.63193 20.5 5.34327 20.2049 5.34116 19.8396V12.9014H4.14302C3.88309 12.9001 3.64926 12.7388 3.54961 12.4923C3.4497 12.2454 3.50348 11.9614 3.6859 11.771L11.5426 3.6951C11.6639 3.57018 11.8284 3.5 12 3.5C12.1716 3.5 12.3361 3.57018 12.4574 3.6951L20.3141 11.771C20.4965 11.9615 20.5503 12.2454 20.4504 12.4923C20.3507 12.7388 20.1169 12.9001 19.857 12.9014H19.8572Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const HomeFilledIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.4037 11.375L12.8556 3.60577C12.4133 3.14423 11.596 3.14423 11.144 3.60577L3.58635 11.375C3.24981 11.7212 3.15366 12.2404 3.33635 12.6827C3.51904 13.1346 3.95173 13.4327 4.44212 13.4327H5.01904V19.5288C5.01904 20.1923 5.5575 20.7404 6.22096 20.7404H9.47096C10.1152 20.7308 10.644 20.1827 10.644 19.5288L10.6921 15.7308L13.3556 15.7885V19.5288C13.3556 20.1923 13.894 20.7308 14.5575 20.7308H17.7979C18.4517 20.7308 18.9902 20.1923 18.9998 19.5192V13.4231H19.5767C20.0575 13.4231 20.4998 13.125 20.6825 12.6731C20.8652 12.2308 20.769 11.7115 20.4325 11.3558L20.4037 11.375Z"
      fill="currentColor"
    />
  </svg>
);

export const DiaryIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.87913 4.0005L6.76243 4.00049C5.89047 4.00048 5.18359 4.70735 5.18359 5.57931V18.4207C5.18359 19.2926 5.89045 19.9995 6.76241 19.9995L8.87913 19.9995H16.3506C17.7115 19.9995 18.8147 18.8962 18.8147 17.5347V6.46468C18.8147 5.10374 17.7117 4.0005 16.351 4.0005H16.2091L16.209 9.24499L15.0199 8.23576L13.8223 9.24499V4.0005H8.87913ZM8.87913 19.9995V4.0005"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const DiaryFilledIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.68 5.105V18.895C4.68 19.835 5.44 20.595 6.38 20.595H8.28L8.27 3.405H6.37C5.43 3.405 4.67 4.165 4.67 5.105H4.68Z"
      fill="currentColor"
    />
    <path
      d="M16.68 3.405H16.53V9.035L15.25 7.955L13.96 9.035V3.405H9.47V20.595H16.67C18.13 20.595 19.32 19.405 19.32 17.945V6.055C19.32 4.595 18.14 3.405 16.68 3.405Z"
      fill="currentColor"
    />
  </svg>
);

export const StatsIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="3"
      y="12"
      width="3"
      height="8"
      rx="1"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="8"
      y="8"
      width="3"
      height="12"
      rx="1"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="13"
      y="10"
      width="3"
      height="10"
      rx="1"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="18"
      y="4"
      width="3"
      height="16"
      rx="1"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const StatsFilledIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="2.4"
      y="11.4"
      width="4.2"
      height="9.2"
      rx="1.6"
      fill="currentColor"
    />
    <rect
      x="7.4"
      y="7.4"
      width="4.2"
      height="13.2"
      rx="1.6"
      fill="currentColor"
    />
    <rect
      x="12.4"
      y="9.4"
      width="4.2"
      height="11.2"
      rx="1.6"
      fill="currentColor"
    />
    <rect
      x="17.4"
      y="3.4"
      width="4.2"
      height="17.2"
      rx="1.6"
      fill="currentColor"
    />
  </svg>
);

export const MailIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.75 7.03C20.56 6.7 20.29 6.43 19.96 6.25H19.95C19.67 6.09 19.34 6 19 6H5C4.66 6 4.33 6.09 4.05 6.25H4.04C3.71 6.43 3.44 6.7 3.25 7.03C3.09 7.32 3 7.65 3 8V16C3 17.1 3.9 18 5 18H19C20.1 18 21 17.1 21 16V8C21 7.65 20.91 7.32 20.75 7.03ZM19.5 16C19.5 16.28 19.28 16.5 19 16.5H5C4.72 16.5 4.5 16.28 4.5 16V8C4.5 7.72 4.72 7.5 5 7.5H19C19.28 7.5 19.5 7.72 19.5 8V16Z"
      fill="currentColor"
    />
    <path
      d="M20.75 7.03C20.74 7.23 20.65 7.42 20.49 7.56L19.5 8.43L12.49 14.56C12.35 14.69 12.18 14.75 12 14.75C11.82 14.75 11.65 14.69 11.51 14.56L4.5 8.43L3.51 7.56C3.35 7.42 3.26 7.23 3.25 7.03C3.44 6.7 3.71 6.43 4.04 6.25H4.05C4.2 6.26 4.36 6.32 4.49 6.44L5.7 7.5L12 13L18.3 7.5L19.51 6.44C19.64 6.32 19.8 6.26 19.95 6.25H19.96C20.29 6.43 20.56 6.7 20.75 7.03Z"
      fill="currentColor"
    />
  </svg>
);

export const MailFilledIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.84 6.19C19.58 6.07 19.3 6 19 6H4.99997C4.69997 6 4.41997 6.07 4.15997 6.19L12 13.05L19.84 6.19Z"
      fill="currentColor"
    />
    <path
      d="M20.73 7.01001L12.4 14.3C12.29 14.4 12.15 14.45 12 14.45C11.85 14.45 11.72 14.4 11.6 14.3L3.27 7.01001C3.1 7.30001 3 7.64001 3 8.00001V16C3 17.1 3.9 18 5 18H19C20.1 18 21 17.1 21 16V8.00001C21 7.64001 20.9 7.30001 20.73 7.01001Z"
      fill="currentColor"
    />
  </svg>
);

export const PartnersIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask id="sidebar-partners-1" fill="white">
      <rect x="3.5" y="13.5" width="7" height="7" rx="1" />
    </mask>
    <rect
      x="3.5"
      y="13.5"
      width="7"
      height="7"
      rx="1"
      stroke="currentColor"
      strokeWidth="3"
      mask="url(#sidebar-partners-1)"
    />
    <mask id="sidebar-partners-2" fill="white">
      <rect x="13.5" y="13.5" width="7" height="7" rx="1" />
    </mask>
    <rect
      x="13.5"
      y="13.5"
      width="7"
      height="7"
      rx="1"
      stroke="currentColor"
      strokeWidth="3"
      mask="url(#sidebar-partners-2)"
    />
    <mask id="sidebar-partners-3" fill="white">
      <rect x="13.5" y="3.5" width="7" height="7" rx="1" />
    </mask>
    <rect
      x="13.5"
      y="3.5"
      width="7"
      height="7"
      rx="1"
      stroke="currentColor"
      strokeWidth="3"
      mask="url(#sidebar-partners-3)"
    />
    <mask id="sidebar-partners-4" fill="white">
      <rect x="3.5" y="3.5" width="7" height="7" rx="1" />
    </mask>
    <rect
      x="3.5"
      y="3.5"
      width="7"
      height="7"
      rx="1"
      stroke="currentColor"
      strokeWidth="3"
      mask="url(#sidebar-partners-4)"
    />
  </svg>
);

export const PartnersFilledIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="3.5" y="3.5" width="7" height="7" rx="1" fill="currentColor" />
    <rect x="13.5" y="3.5" width="7" height="7" rx="1" fill="currentColor" />
    <rect x="3.5" y="13.5" width="7" height="7" rx="1" fill="currentColor" />
    <rect x="13.5" y="13.5" width="7" height="7" rx="1" fill="currentColor" />
  </svg>
);

export const SchoolLinksIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 7.17148C21 6.10206 20.5927 5.02971 19.7812 4.21812C18.158 2.59494 15.4976 2.59494 13.8744 4.21812L11.132 6.96053C10.8332 7.25059 10.8302 7.72817 11.1203 8.02702C11.4104 8.32587 11.8879 8.3288 12.1868 8.03874L14.9526 5.27289C16.0015 4.22398 17.6775 4.22398 18.7264 5.27289C19.7753 6.3218 19.7753 7.99772 18.7264 9.04663L15.0464 12.7266C13.9975 13.7755 12.3216 13.7755 11.2726 12.7266C11.1496 12.6036 11.0617 12.4659 10.9679 12.3282C10.7335 11.9853 10.2677 11.8945 9.92488 12.1289C9.58208 12.3633 9.49125 12.8292 9.72565 13.172C9.87214 13.3859 10.0304 13.5939 10.2179 13.7814C11.8411 15.4046 14.5014 15.4046 16.1246 13.7814L19.7812 10.1248C20.5927 9.31326 21 8.2409 21 7.17148ZM14.3432 11.0859C14.3373 11.0536 14.3286 11.0214 14.3198 10.9921C14.2963 10.8808 14.2495 10.7782 14.1791 10.6874C14.059 10.5292 13.9272 10.3651 13.7807 10.2186C12.1575 8.59543 9.49711 8.59543 7.87393 10.2186L4.21738 13.8752C2.59421 15.4983 2.59421 18.1587 4.21738 19.7819C5.84056 21.4051 8.50094 21.4051 10.1241 19.7819L12.8431 17.0395C13.0658 16.8578 13.1683 16.5678 13.1038 16.2865C13.0394 16.0081 12.8196 15.7884 12.5413 15.7239C12.26 15.6595 11.97 15.762 11.7883 15.9847L9.0459 18.7271C7.99699 19.776 6.32107 19.776 5.27216 18.7271C4.22324 17.6782 4.22324 16.0023 5.27216 14.9534L8.95214 11.2734C10.0011 10.2245 11.677 10.2245 12.7259 11.2734C12.8196 11.3642 12.8841 11.4755 12.9603 11.5781C13.1449 11.8799 13.517 12.0117 13.851 11.8916C14.185 11.7744 14.3901 11.4375 14.3432 11.0859Z"
      fill="currentColor"
    />
  </svg>
);

export const SubscriptionIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#sidebar-family-kit-clip)">
      <path
        d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5ZM11.9932 4.91699C11.8006 4.92077 11.6127 4.97822 11.4512 5.08301C11.33 5.16161 11.2269 5.26468 11.1484 5.38477L11.083 5.50098L9.50293 8.67969L9.49805 8.69043L9.49316 8.69922L9.48535 8.7002L9.47363 8.70215L5.96387 9.2168L5.95605 9.21777C5.81579 9.24054 5.68223 9.29193 5.56348 9.36816L5.4502 9.45312C5.30619 9.5764 5.1985 9.73671 5.13965 9.91699C5.08083 10.0972 5.0727 10.2901 5.11621 10.4746C5.15976 10.6591 5.2535 10.8279 5.38672 10.9629L5.39648 10.9727L7.94824 13.416C7.94841 13.4179 7.94881 13.4201 7.94824 13.4219L7.9375 13.4541L7.93262 13.4873L7.34375 16.9795H7.34473C7.30881 17.1691 7.32571 17.3648 7.39551 17.5449C7.4677 17.7313 7.5928 17.8929 7.75488 18.0098C7.9173 18.1269 8.11041 18.1935 8.30957 18.2031C8.50218 18.2123 8.69224 18.1658 8.86035 18.0723L8.86133 18.0742L11.96 16.4326C11.9754 16.426 11.992 16.4229 12.0088 16.4229C12.025 16.4229 12.0408 16.4265 12.0557 16.4326L15.1562 18.0742V18.0723C15.3247 18.1663 15.5159 18.2124 15.709 18.2031C15.908 18.1935 16.1004 18.1267 16.2627 18.0098H16.2637C16.4256 17.8929 16.5499 17.7311 16.6221 17.5449C16.6904 17.3687 16.7067 17.1778 16.6738 16.9922H16.6758L16.1797 13.5L16.167 13.415L16.1348 13.3535L18.6201 10.9922L18.6191 10.9912C18.7605 10.8583 18.8628 10.6896 18.9121 10.502V10.501C18.9615 10.3116 18.9563 10.1117 18.8965 9.9248C18.8367 9.73825 18.7247 9.57195 18.5742 9.44629L18.4561 9.36133C18.3346 9.28627 18.1984 9.23773 18.0557 9.21777L18.0566 9.2168L14.5469 8.68359L14.5342 8.68262L14.5234 8.68066L14.5205 8.67188L14.5146 8.66211L12.9346 5.48242L12.9307 5.47559L12.8555 5.35254C12.7725 5.23559 12.6661 5.13642 12.542 5.0625C12.3764 4.96393 12.1859 4.91327 11.9932 4.91699Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="sidebar-family-kit-clip">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationsIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.84668 15.5548L19.0713 19.2963C19.2911 19.3688 19.525 19.3881 19.7537 19.3525C19.9823 19.3169 20.1993 19.2275 20.3867 19.0917C20.5755 18.9573 20.7297 18.7798 20.8365 18.5739C20.9432 18.3681 20.9995 18.1398 21.0005 17.9079V5.87945C20.9995 5.64758 20.9432 5.41928 20.8365 5.21344C20.7297 5.0076 20.5755 4.83009 20.3867 4.6956C20.198 4.56222 19.9805 4.47547 19.7518 4.44243C19.5232 4.40942 19.2899 4.43106 19.0713 4.5056L7.84668 8.24714V15.5548Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 11.901C2 12.3809 2.09451 12.856 2.27813 13.2993C2.46176 13.7426 2.7309 14.1454 3.07018 14.4847C3.75541 15.1699 4.68479 15.5549 5.65385 15.5549H7.84615V8.24719H5.65385C5.17402 8.24719 4.69889 8.3417 4.25558 8.52532C3.81228 8.70895 3.40948 8.97809 3.07018 9.31737C2.38496 10.0026 2 10.932 2 11.901Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.65332 15.5549V17.0165C5.65332 17.4963 5.74782 17.9715 5.93145 18.4148C6.11508 18.858 6.38422 19.2608 6.7235 19.6001C7.0628 19.9394 7.4656 20.2085 7.9089 20.3922C8.35221 20.5758 8.82734 20.6703 9.30717 20.6703"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotificationsFilledIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.875 8.21298L18.9345 4.15513C20.4094 3.58153 22 4.66958 22 6.25214V18.5913C22 20.127 20.4955 21.2115 19.0385 20.7258L8.875 17.213V8.21298ZM5.5 8.21307H7V18.7131C7 19.5415 7.67158 20.2131 8.5 20.2131H9.25C10.0784 20.2131 10.75 20.8846 10.75 21.7131C10.75 22.5415 10.0784 23.2131 9.25 23.2131H8.5C6.01472 23.2131 4 21.1984 4 18.7131V16.957C2.25221 16.3393 1 14.6724 1 12.7131C1 10.2278 3.01472 8.21307 5.5 8.21307Z"
      fill="currentColor"
    />
  </svg>
);

export const HelpIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 3.75C14.188 3.75 16.2869 4.61882 17.834 6.16602C19.3812 7.71317 20.25 9.812 20.25 12C20.25 14.188 19.3812 16.2869 17.834 17.834C16.2868 19.3812 14.188 20.25 12 20.25C9.81199 20.25 7.71309 19.3812 6.16602 17.834C4.6188 16.2868 3.75 14.188 3.75 12C3.75 9.81199 4.61882 7.71309 6.16602 6.16602C7.71317 4.6188 9.81194 3.75 12 3.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.6805 15.5785C12.6842 16.1563 12.3601 16.5 11.7931 16.5C11.2261 16.5 10.8482 16.1688 10.8463 15.6847C10.8463 15.0133 11.1469 14.6785 11.7463 14.6605C12.2342 14.6461 12.7417 14.9449 12.6805 15.5785ZM13.9405 11.424C13.6849 11.622 13.4167 11.8021 13.1593 11.9964C12.7797 12.2452 12.5616 12.6772 12.587 13.1303C12.5932 13.2911 12.5458 13.4491 12.4517 13.5797C12.3578 13.7102 12.2229 13.8055 12.0685 13.8503C11.9042 13.9136 11.7234 13.9205 11.5546 13.87C11.3859 13.8195 11.2387 13.7144 11.1361 13.5713C11.0688 13.4585 11.0323 13.3301 11.0299 13.1988C11.0036 12.3729 11.3869 11.5873 12.0541 11.0999C12.343 10.8801 12.6156 10.6394 12.8694 10.38C12.9905 10.2374 13.0642 10.0606 13.0801 9.87415C13.1216 9.36475 12.794 9.03719 12.2665 9.00292C11.6293 8.96149 11.0929 9.1271 10.7203 9.69048C10.6422 9.82332 10.5253 9.92904 10.3853 9.99345C10.2453 10.0579 10.089 10.0777 9.93733 10.0506C9.3973 9.96056 9.16516 9.52135 9.3865 9.01562C9.61827 8.52268 10.0167 8.12742 10.5115 7.89966C11.0197 7.6498 11.5762 7.51344 12.1423 7.5C12.4625 7.5334 12.7804 7.58576 13.0944 7.65657C14.0538 7.9284 14.6245 8.69516 14.6964 9.71395C14.7671 10.3784 14.4783 11.03 13.9387 11.4239L13.9405 11.424Z"
      fill="currentColor"
    />
  </svg>
);

export const HelpFilledIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C9.61302 3 7.32389 3.94821 5.63608 5.63608C3.94821 7.32383 3 9.61309 3 12C3 14.3869 3.94821 16.6761 5.63608 18.3639C7.32383 20.0518 9.61309 21 12 21C14.3869 21 16.6761 20.0518 18.3639 18.3639C20.0518 16.6762 21 14.3869 21 12C21 9.61309 20.0518 7.32389 18.3639 5.63608C16.6762 3.94821 14.3869 3 12 3ZM11.7931 16.5C12.3601 16.5 12.6842 16.1563 12.6805 15.5785C12.7417 14.9449 12.2342 14.6461 11.7463 14.6605C11.1469 14.6785 10.8463 15.0133 10.8463 15.6847C10.8482 16.1688 11.2261 16.5 11.7931 16.5ZM13.5112 11.7398C13.6555 11.6364 13.7999 11.5329 13.9405 11.424L13.9387 11.4239C14.4783 11.03 14.7671 10.3784 14.6964 9.71395C14.6245 8.69516 14.0538 7.9284 13.0944 7.65657C12.7804 7.58576 12.4625 7.5334 12.1423 7.5C11.5762 7.51344 11.0197 7.6498 10.5115 7.89966C10.0167 8.12742 9.61827 8.52268 9.3865 9.01562C9.16516 9.52135 9.3973 9.96056 9.93733 10.0506C10.089 10.0777 10.2453 10.0579 10.3853 9.99345C10.5253 9.92904 10.6422 9.82332 10.7203 9.69048C11.0929 9.1271 11.6293 8.96149 12.2665 9.00292C12.794 9.03719 13.1216 9.36475 13.0801 9.87415C13.0642 10.0606 12.9905 10.2374 12.8694 10.38C12.6156 10.6394 12.343 10.8801 12.0541 11.0999C11.3869 11.5873 11.0036 12.3729 11.0299 13.1988C11.0323 13.3301 11.0688 13.4585 11.1361 13.5713C11.2387 13.7144 11.3859 13.8195 11.5546 13.87C11.7234 13.9205 11.9042 13.9136 12.0685 13.8503C12.2229 13.8055 12.3578 13.7102 12.4517 13.5797C12.5458 13.4491 12.5932 13.2911 12.587 13.1303C12.5616 12.6772 12.7797 12.2452 13.1593 11.9964C13.2751 11.909 13.3931 11.8244 13.5112 11.7398Z"
      fill="currentColor"
    />
  </svg>
);

export const LogoutIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.1148 18.5769V20.0385C17.1148 20.4261 16.9607 20.7979 16.6867 21.0719C16.4127 21.346 16.0409 21.5 15.6532 21.5H5.42248C5.03485 21.5 4.6631 21.346 4.38901 21.0719C4.11493 20.7979 3.96094 20.4261 3.96094 20.0385V3.96154C3.96094 3.57391 4.11493 3.20217 4.38901 2.92807C4.6631 2.65398 5.03485 2.5 5.42248 2.5H15.6532C16.0409 2.5 16.4127 2.65398 16.6867 2.92807C16.9607 3.20217 17.1148 3.57391 17.1148 3.96154V5.42308"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.80664 12H20.0374"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1152 9.0769L20.0383 12L17.1152 14.9231"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SunIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.25006C12.4808 2.25006 12.8705 2.63981 12.8705 3.1206V4.51345C12.8705 4.99424 12.4808 5.38399 12 5.38399C11.5192 5.38399 11.1295 4.99424 11.1295 4.51345V3.1206C11.1295 2.63981 11.5192 2.25006 12 2.25006ZM12 8.51792C10.0769 8.51792 8.51786 10.0769 8.51786 12.0001C8.51786 13.9232 10.0769 15.4822 12 15.4822C13.9231 15.4822 15.4821 13.9232 15.4821 12.0001C15.4821 10.0769 13.9231 8.51792 12 8.51792ZM6.77679 12.0001C6.77679 9.11536 9.1153 6.77685 12 6.77685C14.8847 6.77685 17.2232 9.11536 17.2232 12.0001C17.2232 14.8848 14.8847 17.2233 12 17.2233C9.1153 17.2233 6.77679 14.8848 6.77679 12.0001ZM12.8705 19.4867C12.8705 19.0059 12.4808 18.6161 12 18.6161C11.5192 18.6161 11.1295 19.0059 11.1295 19.4867V20.8795C11.1295 21.3603 11.5192 21.7501 12 21.7501C12.4808 21.7501 12.8705 21.3603 12.8705 20.8795V19.4867ZM21.75 12.0001C21.75 12.4808 21.3603 12.8706 20.8795 12.8706H19.4866C19.0058 12.8706 18.6161 12.4808 18.6161 12.0001C18.6161 11.5193 19.0058 11.1295 19.4866 11.1295H20.8795C21.3603 11.1295 21.75 11.5193 21.75 12.0001ZM4.51339 12.8706C4.99418 12.8706 5.38393 12.4808 5.38393 12.0001C5.38393 11.5193 4.99418 11.1295 4.51339 11.1295H3.12054C2.63975 11.1295 2.25 11.5193 2.25 12.0001C2.25 12.4808 2.63975 12.8706 3.12054 12.8706H4.51339ZM5.10571 5.10577C5.44566 4.7658 5.99686 4.7658 6.33682 5.10577L7.32173 6.09066C7.66168 6.43062 7.66168 6.98182 7.32173 7.32179C6.98176 7.66174 6.43056 7.66174 6.09059 7.32179L5.10571 6.33688C4.76574 5.99692 4.76574 5.44572 5.10571 5.10577ZM17.9095 16.6784C17.5695 16.3385 17.0183 16.3385 16.6783 16.6784C16.3383 17.0184 16.3383 17.5695 16.6783 17.9095L17.6632 18.8944C18.0032 19.2344 18.5544 19.2344 18.8944 18.8944C19.2342 18.5546 19.2342 18.0033 18.8944 17.6633L17.9095 16.6784ZM18.8944 5.10577C19.2342 5.44572 19.2342 5.99692 18.8944 6.33688L17.9093 7.32179C17.5695 7.66174 17.0182 7.66174 16.6783 7.32179C16.3383 6.98182 16.3383 6.43062 16.6783 6.09066L17.6632 5.10577C18.0031 4.7658 18.5544 4.7658 18.8944 5.10577ZM7.3217 17.9095C7.66167 17.5695 7.66167 17.0184 7.3217 16.6784C6.98173 16.3385 6.43055 16.3385 6.09058 16.6784L5.10568 17.6633C4.76571 18.0033 4.76571 18.5546 5.10568 18.8944C5.44565 19.2344 5.99684 19.2344 6.3368 18.8944L7.3217 17.9095Z"
      fill="currentColor"
    />
  </svg>
);

export const SunFilledIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="5" fill="currentColor" />
    <path
      d="M12 2v2M12 20v2M2 12h2M20 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4l1.4-1.4M17 7l1.4-1.4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const MoonIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.354 14.354A9 9 0 0 1 9.646 3.646 9 9 0 1 0 20.354 14.354z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContrastIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="7.5"
      cy="14.5"
      r="3.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle
      cx="16.5"
      cy="14.5"
      r="3.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M11 14.5h2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4 14.5L5.5 8.5C5.7 7.8 6.3 7.5 7 7.5h10c0.7 0 1.3 0.3 1.5 1L20 14.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SystemIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 3a9 9 0 0 1 0 18V3z" fill="currentColor" />
  </svg>
);

export const ThreeDotsIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="5" cy="12" r="1.6" fill="currentColor" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    <circle cx="19" cy="12" r="1.6" fill="currentColor" />
  </svg>
);

export const PlusIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 4V20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 12H4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRightIcon: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6 3L11 8L6 13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
